// removed by extract-text-webpack-plugin
module.exports = {"form":"mail-in-settings__form___268cu"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/mail-in-settings.scss
// module id = 1361
// module chunks = 0